import { useState } from 'react';
import { LayoutDashboard, Plug, Activity, Sun, BarChart3, Lightbulb, FileText, User, HelpCircle, Menu, X, Zap } from 'lucide-react';

const ITEMS = [
  { id: 'home',       label: 'Overzicht',         Icon: LayoutDashboard },
  { id: 'apparaten',  label: 'Apparaten',         Icon: Plug },
  { id: 'p1',         label: 'P1 / slimme meter', Icon: Activity },
  { id: 'zonnestroom',label: 'Zonnestroom',       Icon: Sun },
  { id: 'verbruik',   label: 'Verbruik',          Icon: BarChart3 },
  { id: 'advies',     label: 'Advies',            Icon: Lightbulb },
  { id: 'offertes',   label: 'Offertes',          Icon: FileText },
  { id: 'account',    label: 'Account',           Icon: User },
  { id: 'help',       label: 'Hulp',              Icon: HelpCircle },
];

function NavItem({ item, active, onClick }) {
  const { Icon, label, id } = item;
  return (
    <button
      onClick={onClick}
      data-testid={`app-sidebar-${id}`}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left text-sm transition-colors ${
        active
          ? 'bg-emerald-500/15 text-emerald-300 border border-emerald-400/30'
          : 'text-white/70 hover:bg-white/5 hover:text-white border border-transparent'
      }`}
    >
      <Icon className="w-4 h-4 shrink-0" />
      <span className="font-medium">{label}</span>
    </button>
  );
}

export default function AppSidebar({ tab, onChange, children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const go = (id) => { onChange(id); setDrawerOpen(false); };

  const SidebarBody = (
    <>
      <div className="flex items-center gap-2 px-3 mb-5">
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-emerald-500/20 text-emerald-300 border border-emerald-400/30">
          <Zap className="w-4 h-4" />
        </span>
        <span className="text-base font-semibold text-white" style={{ fontFamily: 'Outfit' }}>Mijn Powersure</span>
      </div>
      <nav className="space-y-1">
        {ITEMS.map((it) => (
          <NavItem key={it.id} item={it} active={tab === it.id} onClick={() => go(it.id)} />
        ))}
      </nav>
      <p className="text-[10px] text-white/35 mt-6 px-3 leading-snug">
        Dark premium · v Powersure 1.0
      </p>
    </>
  );

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #0a1410 0%, #050a08 100%)' }}>
      {/* Mobile drawer trigger */}
      <button
        onClick={() => setDrawerOpen(true)}
        data-testid="app-drawer-open"
        className="md:hidden fixed top-3 left-3 z-30 w-10 h-10 inline-flex items-center justify-center rounded-lg bg-white/8 border border-white/15 text-white/85 backdrop-blur-md"
      >
        <Menu className="w-5 h-5" />
      </button>

      {/* Mobile drawer overlay */}
      {drawerOpen && (
        <div className="md:hidden fixed inset-0 z-40" data-testid="app-drawer">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setDrawerOpen(false)} />
          <aside
            className="absolute left-0 top-0 bottom-0 w-72 p-4 pt-5 border-r border-white/10 overflow-y-auto"
            style={{ background: 'linear-gradient(180deg, #0e1b16 0%, #0a1410 100%)' }}
          >
            <button
              onClick={() => setDrawerOpen(false)}
              data-testid="app-drawer-close"
              className="absolute top-3 right-3 w-8 h-8 inline-flex items-center justify-center rounded-md text-white/60 hover:text-white hover:bg-white/5"
            >
              <X className="w-4 h-4" />
            </button>
            {SidebarBody}
          </aside>
        </div>
      )}

      <div className="flex">
        {/* Desktop sticky sidebar */}
        <aside
          className="hidden md:flex md:flex-col md:w-60 md:shrink-0 md:sticky md:top-0 md:h-screen md:py-6 md:px-3 md:border-r md:border-white/10"
          style={{ background: 'linear-gradient(180deg, #0e1b16 0%, #0a1410 100%)' }}
          data-testid="app-sidebar"
        >
          {SidebarBody}
        </aside>

        {/* Content */}
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}
